"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UncheckedIcon = void 0;
const react_1 = require("react");
const React = require("react");
class UncheckedIcon extends react_1.Component {
    render() {
        return (React.createElement("svg", { width: "17px", height: "17px", viewBox: "0 0 17 17", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("defs", null,
                React.createElement("rect", { x: "0", y: "0", width: "17", height: "17", rx: "2" })),
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", transform: "translate(-71.000000, -523.000000)" },
                React.createElement("g", { id: "form-/-checkbox-/-tiny-/-unchecked", transform: "translate(71.000000, 523.000000)" },
                    React.createElement("g", { strokeWidth: "1", fillRule: "evenodd", transform: "translate(-1.000000, -1.000000)" }),
                    React.createElement("g", null,
                        React.createElement("use", { fillOpacity: "0.5", fill: "#FFFFFF", fillRule: "evenodd", xlinkHref: "#path-1" }),
                        React.createElement("rect", { strokeOpacity: "0.1", stroke: "#000000", strokeWidth: "1", x: "0.5", y: "0.5", width: "16", height: "16", rx: "2" }))))));
    }
}
exports.UncheckedIcon = UncheckedIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/unchecked.tsx
// module id = 2169
// module chunks = 0 1 2